import React, { useState, useEffect } from 'react';
import { FlightDetails, I18NCity } from '../interface/flight.details';
import { TripType } from '@industronics/fids-utils';
import { filterPosAviationStationLangs } from '../utils/common.utils';

interface DestinationProps {
  flight: FlightDetails;
  style?: React.CSSProperties;
  className?: string;
  tick?: number;
}

const Destination: React.FC<DestinationProps> = ({ flight, className, tick }) => {
  const [items, setItems] = useState<string[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    let stations: string[] = [];

    if (flight.tripType === TripType.Arrival) {
      stations = flight.stations.slice(0, -1).flatMap(
        (station: { translations: I18NCity[] }) =>
          filterPosAviationStationLangs(station.translations).map(t => t.value)
      );
    } else if (flight.tripType === TripType.Departure) {
      stations = flight.stations.slice(1).flatMap(
        (station: { translations: I18NCity[] }) =>
          filterPosAviationStationLangs(station.translations).map(t => t.value)
      );
    }
    setItems(stations);
  }, [flight]);

  useEffect(() => {
    if (items.length <= 1 || tick === undefined) return;
    setCurrentIndex(tick % items.length);
    setIsAnimating(true);
    const timeout = setTimeout(() => setIsAnimating(false), 600);
    return () => clearTimeout(timeout);
  }, [tick]);

  if (items.length === 0) return null;

  return (
    <div className="design2-flip-container">
      <div className={`design2-flip-item ${isAnimating ? 'animate-flip' : ''}`}>
        <span className={className}>{items[currentIndex]?.toUpperCase()}</span>
      </div>
    </div>
  );
};

export default Destination;
